export default __webpack_public_path__ + "static/media/logo_white.c6ae2586.svg";